module.exports = __webpack_public_path__ + "img/file.eed6e46f.png";